import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.replace";
import _classCallCheck from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _get from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/get";
import _inherits from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import _possibleConstructorReturn from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/archive/projects/work/citf/sct/src/sct/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/view/editableelement
 */
import ContainerElement from "./containerelement";
import CKEditorError from '@ckeditor/ckeditor5-utils/src/ckeditorerror';
import mix from '@ckeditor/ckeditor5-utils/src/mix';
import ObservableMixin from '@ckeditor/ckeditor5-utils/src/observablemixin';
var documentSymbol = Symbol('document');
/**
 * Editable element which can be a {@link module:engine/view/rooteditableelement~RootEditableElement root}
 * or nested editable area in the editor.
 *
 * Editable is automatically read-only when its {@link module:engine/view/document~Document Document} is read-only.
 *
 * The constructor of this class shouldn't be used directly. To create new `EditableElement` use the
 * {@link module:engine/view/downcastwriter~DowncastWriter#createEditableElement `downcastWriter#createEditableElement()`} method.
 *
 * @extends module:engine/view/containerelement~ContainerElement
 * @mixes module:utils/observablemixin~ObservableMixin
 */

var EditableElement = /*#__PURE__*/function (_ContainerElement) {
  _inherits(EditableElement, _ContainerElement);

  var _super = _createSuper(EditableElement);

  /**
   * Creates an editable element.
   *
   * @see module:engine/view/downcastwriter~DowncastWriter#createEditableElement
   * @protected
   */
  function EditableElement(name, attrs, children) {
    var _this;

    _classCallCheck(this, EditableElement);

    _this = _super.call(this, name, attrs, children);
    /**
     * Whether the editable is in read-write or read-only mode.
     *
     * @observable
     * @member {Boolean} module:engine/view/editableelement~EditableElement#isReadOnly
     */

    _this.set('isReadOnly', false);
    /**
     * Whether the editable is focused.
     *
     * This property updates when {@link module:engine/view/document~Document#isFocused document.isFocused} or view
     * selection is changed.
     *
     * @readonly
     * @observable
     * @member {Boolean} module:engine/view/editableelement~EditableElement#isFocused
     */


    _this.set('isFocused', false);
    /**
     * The {@link module:engine/view/document~Document} which is an owner of this root.
     * Can only by set once.
     * Throws {@link module:utils/ckeditorerror~CKEditorError CKEditorError} `view-editableelement-document-already-set`
     * when document is already set.
     *
     * @member {module:engine/view/document~Document} #document
     */


    return _this;
  }
  /**
   * Checks whether this object is of the given.
   *
   *		editableElement.is( 'editableElement' ); // -> true
   *		editableElement.is( 'element' ); // -> true
   *		editableElement.is( 'node' ); // -> true
   *		editableElement.is( 'view:editableElement' ); // -> true
   *		editableElement.is( 'view:element' ); // -> true
   *		editableElement.is( 'view:node' ); // -> true
   *
   *		editableElement.is( 'model:element' ); // -> false
   *		editableElement.is( 'documentFragment' ); // -> false
   *
   * Assuming that the object being checked is an editbale element, you can also check its
   * {@link module:engine/view/editableelement~EditableElement#name name}:
   *
   *		editableElement.is( 'div' ); // -> true if this is a div element
   *		editableElement.is( 'editableElement', 'div' ); // -> same as above
   *		text.is( 'div' ); -> false
   *
   * {@link module:engine/view/node~Node#is Check the entire list of view objects} which implement the `is()` method.
   *
   * @param {String} type Type to check when `name` parameter is present.
   * Otherwise, it acts like the `name` parameter.
   * @param {String} [name] Element name.
   * @returns {Boolean}
   */


  _createClass(EditableElement, [{
    key: "is",
    value: function is(type) {
      var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var cutType = type && type.replace(/^view:/, '');

      if (!name) {
        return cutType == 'editableElement' || _get(_getPrototypeOf(EditableElement.prototype), "is", this).call(this, type);
      } else {
        return cutType == 'editableElement' && name == this.name || _get(_getPrototypeOf(EditableElement.prototype), "is", this).call(this, type, name);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.stopListening();
    }
    /**
     * Returns document associated with the editable.
     *
     * @readonly
     * @returns {module:engine/view/document~Document}
     */

  }, {
    key: "document",
    get: function get() {
      return this.getCustomProperty(documentSymbol);
    }
    /**
     * Sets document of this editable element.
     *
     * @protected
     * @param {module:engine/view/document~Document} document
     */

  }, {
    key: "_document",
    set: function set(document) {
      var _this2 = this;

      if (this.getCustomProperty(documentSymbol)) {
        /**
         * View document is already set. It can only be set once.
         *
         * @error view-editableelement-document-already-set
         */
        throw new CKEditorError('view-editableelement-document-already-set: View document is already set.', this);
      }

      this._setCustomProperty(documentSymbol, document);

      this.bind('isReadOnly').to(document);
      this.bind('isFocused').to(document, 'isFocused', function (isFocused) {
        return isFocused && document.selection.editableElement == _this2;
      }); // Update focus state based on selection changes.

      this.listenTo(document.selection, 'change', function () {
        _this2.isFocused = document.isFocused && document.selection.editableElement == _this2;
      });
    }
  }]);

  return EditableElement;
}(ContainerElement);

export { EditableElement as default };
mix(EditableElement, ObservableMixin);